import { render } from "./itinerario_ingles.vue?vue&type=template&id=ad56632c&scoped=true"
import script from "./itinerario_ingles.vue?vue&type=script&lang=js"
export * from "./itinerario_ingles.vue?vue&type=script&lang=js"

import "./itinerario_ingles.vue?vue&type=style&index=0&id=ad56632c&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-ad56632c"]])

export default __exports__